var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"vx-navbar-wrapper",class:_vm.classObj,attrs:{"id":"vs_navbar"}},[_c('vs-navbar',{staticClass:"vx-navbar navbar-custom navbar-skelton",class:_vm.textColor,attrs:{"color":_vm.navbarColorLocal}},[_c('feather-icon',{class:[
          'sm:inline-flex xl cursor-pointer p-2',
          { 'xl:hidden': _vm.$route.fullPath.includes('admin') },
        ],attrs:{"id":"featherIcon","icon":"MenuIcon"},on:{"click":_vm.showSidebar}}),_c('title-route',{class:{ 'pl-3': _vm.showSidebar }}),_c('vs-spacer'),_c('profile-drop-down')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }